<template>
  <button class="search-calendar" tabindex="0">
    <div id="searchDates" class="search-input from" @click="togglePanel" :class="{'open': datesPanel?.visible && _isFromClicked}">
      <div class="search-input__label">{{ t('Check-in')}}</div>
      <div class="search-input__body">
        <div class="search-input__icon">
          <img src="/icons/calendar.svg" alt="c">
        </div>
        <div class="search-input__input" :class="{'search-input__input--placeholder': !searchStore.formattedDates[0] }">
          {{searchStore.formattedDates[0] || t('Select date')}}
        </div>
      </div>
    </div>
    <div v-if="!singleDate" class="search-input no-icon to" @click="togglePanel" :class="{'open': datesPanel?.visible && !_isFromClicked}">
      <div class="search-input__label">{{$t('Check-out')}}</div>
      <div class="search-input__body">
        <div class="search-input__input" :class="{'search-input__input--placeholder': !searchStore.formattedDates[1] }">
        {{searchStore.formattedDates[1] || t('Select date')}}
        </div>
      </div>
    </div>
  </button>
  <Popover ref="datesPanel" class="no-arrow">
    <CalendarRange @date-changed="onDateSelected"/>
  </Popover>
  <LazyPropertyPageBookingOverlayCalendar
      v-if="isDatesPanelVisible"
      @close="onDatesPanelClose"
      @date-changed="onDatesChange"
  />
</template>

<script setup lang="ts">
import { useSearchStore } from '~/store/search'
import Popover from "primevue/popover";
import dayjs from '~/utils/dayjs'
import { useI18n } from 'vue-i18n';
const { t } = useI18n()
const props = defineProps({
  singleDate: {
    type: Boolean,
    default: false
  }
})
onMounted(async () => {
  const route = useRoute()
  const date_start = route.query?.['date_start'] || route.query?.['checkin-date']
  const date_end = route.query?.['date_end'] || route.query?.['checkout-date']
  if (date_start && date_end) {
    searchStore.setDates([date_start, date_end])
    searchStore.setFormattedDates([
      dayjs(Array.isArray(date_start) ? date_start[0] : date_start, 'YYYY-MM-DD').format('ddd, DD MMM'), 
      dayjs(Array.isArray(date_end) ? date_end[0] : date_end, 'YYYY-MM-DD').format('ddd, DD MMM')
    ])
  }
});


const searchStore = useSearchStore()

const datesPanel = ref();
const _isFromClicked = ref(true)
const isDatesPanelVisible = ref(false)

//methods
function togglePanel(event: any) {
  //get window width
  const windowWidth = window.innerWidth
  if (windowWidth < 750) {
    showDatesPanel()
    return
  }

  const { target, currentTarget } = event || {}
  const { offsetParent } = target || {}

  _isFromClicked.value = target?.classList.contains('from') || offsetParent?.classList?.contains('from')
  console.log('_isFromClicked', _isFromClicked.value)

  datesPanel.value.toggle(event);
}

function onDatesChange(dates: any) {
  if (dates) {
    searchStore.setDates(dates)
    searchStore.setFormattedDates(dates.map((date:any) => date ? dayjs(date, 'YYYY-MM-DD').format('ddd, DD MMM') : null))
  }
}

function showDatesPanel() {
  isDatesPanelVisible.value = true
}

function onDatesPanelClose() {
  isDatesPanelVisible.value = false
}

function onDateSelected(newDates: any) {
  if (newDates) {
    searchStore.setDates(newDates)
    searchStore.setFormattedDates(newDates.map((date:any) => date ? dayjs(date, 'YYYY-MM-DD').format('ddd, DD MMM') : null))
    if (newDates[0] && newDates[1]) {
      datesPanel.value.hide()
    }
  }
}

</script>

<style scoped lang="scss">
.search-calendar {
  display: flex;
  width: 370px;
  position: relative;
  border-radius: 6px;
  cursor: pointer;

  .search-input__label {
    left: 44px;
    @media screen and (max-width: 768px) {
      left: 32px;
    }
  }

  .no-icon .search-input__label {
    left: 16px;

    @media screen and (max-width: 768px) {
      left: 5px;
    }
  }

  &:hover {
    background-color: var(--light-grey);
    .search-input {
      background-color: var(--light-grey);
    }
  }

  //tablet
  @media (max-width: 1024px) {
    width: 100%;
  }
}

.search-input {
  width: 185px;
  //tablet
  @media (max-width: 1024px) {
    width: 50%;
  }

  &__icon {
    margin-top: -5px;
  }
}

:global(.booking-overlay-container) {
  width: 100%;
  max-width: 708px;
  border-radius: 0;
  height: 100%;
  max-height: 100%;
  padding: 24px;
  overflow-y: auto;
  background: var(--white);
}

</style>
